(function () {
  if (window.__ppLanguageCroLoaded) return;
  window.__ppLanguageCroLoaded = true;

  function locale() {
    return (document.documentElement.lang || 'it').toLowerCase().slice(0, 2);
  }

  const nav = {
    en: {
      'Home':'Home','Cani':'Dogs','Gatti':'Cats','Altri animali':'Other animals','Casa e giardino':'Home & garden',
      'Offerte':'Offers','Blog':'Blog','Chi siamo':'About us',
      'Crocchette Partenopet':'Partenopet kibble','Alimenti secchi':'Dry food','Alimenti umidi':'Wet food',
      'Snack e biscotti':'Treats & biscuits','Cura e igiene':'Care & hygiene','Guinzagli e accessori':'Leads & accessories',
      'Giochi':'Toys','Cucce e cuscini':'Beds & cushions','Lettiere':'Litter','Tiragraffi':'Scratchers',
      'Uccelli':'Birds','Roditori':'Rodents','Tartarughe':'Turtles','Acquariologia':'Aquatics',
      'Piscine e accessori':'Pools & accessories','Giardinaggio e arredo':'Gardening & outdoor furniture',
      'Detergenti Partenopet':'Partenopet detergents'
    },
    es: {
      'Home':'Inicio','Cani':'Perros','Gatti':'Gatos','Altri animali':'Otros animales','Casa e giardino':'Casa y jardín',
      'Offerte':'Ofertas','Blog':'Blog','Chi siamo':'Sobre nosotros',
      'Crocchette Partenopet':'Croquetas Partenopet','Alimenti secchi':'Alimento seco','Alimenti umidi':'Alimento húmedo',
      'Snack e biscotti':'Snacks y galletas','Cura e igiene':'Cuidado e higiene','Guinzagli e accessori':'Correas y accesorios',
      'Giochi':'Juguetes','Cucce e cuscini':'Camas y cojines','Lettiere':'Arena y bandejas','Tiragraffi':'Rascadores',
      'Uccelli':'Aves','Roditori':'Roedores','Tartarughe':'Tortugas','Acquariologia':'Acuariofilia',
      'Piscine e accessori':'Piscinas y accesorios','Giardinaggio e arredo':'Jardinería y mobiliario de exterior',
      'Detergenti Partenopet':'Detergentes Partenopet'
    }
  };

  const globalCopy = {
    it: {
      'Heading':'Informazioni',
      'Add an additional description to your product option. Ex: Size guides, and other common questions.':'Consulta le informazioni aggiuntive relative a questa opzione.',
      'Local Pickup Available':'Ritiro in sede disponibile'
    },
    en: {
      'Spedizione gratuita da 70€ • 10% sul primo ordine con PRIMOORDINE':'Free shipping from €70 • 10% off your first order with PRIMOORDINE',
      'Scopri Partenopet':'Discover Partenopet','Scopri la linea Partenopet':'Discover the Partenopet range','Acquista ora':'Shop now',
      'Crocchette Pressate a Freddo per Cani':'Partenopet Cold-Pressed Dog Food',
      'Crocchette Pressate a Freddo per Gatti':'Partenopet Cold-Pressed Cat Food',
      'Vedi tutti':'View all','Mostra tutti':'View all',
      'Chiedi informazioni':'Ask a question','Condividi con i tuoi amici':'Share with your friends','Condividi':'Share',
      'Descrizione prodotto':'Product description','Prodotti Complementari':'Complementary products','Prodotti complementari':'Complementary products',
      'Altri prodotti':'More products','Prodotti visti di recente':'Recently viewed products','Prodotti consigliati':'Recommended products',
      'Prodotti raccomandati':'Recommended products','GUIDA TAGLIE':'SIZE GUIDE','CONSIGLI DEGLI SPECIALISTI':'SPECIALIST ADVICE',
      'Materiali':'Materials','Caratteristiche':'Features','Cura e manutenzione':'Care & maintenance',
      'Informazioni sulla variante':'Variant information','Informazioni sul colore':'Colour information',
      "Seleziona l'opzione più adatta alle tue esigenze.":'Select the option that best suits your needs.',
      'Seleziona il colore che preferisci.':'Select your preferred colour.',
      'Pagamenti sicuri: PayPal, Klarna e carte':'Secure payments: PayPal, Klarna and cards',
      'Spedizione gratuita da 70€':'Free shipping from €70',
      'Tempi di consegna indicati chiaramente per ogni prodotto':'Delivery times clearly shown for each product',
      'Consegna: 1–4 giorni; alcuni articoli 7–14 giorni':'Delivery: 1–4 business days; some items 7–14 business days',
      "Prendersi cura dei prodotti aiuta anche a ridurne l'impatto ambientale. Segui sempre le indicazioni specifiche del prodotto e utilizza metodi di pulizia delicati quando possibile.":
        'Taking care of products helps extend their life. Always follow the specific care instructions and use gentle cleaning methods when possible.',
      'Non lavare':'Do not wash','Non usare candeggina o sbiancanti':'Do not bleach','Non stirare':'Do not iron',
      'Non lavare a secco':'Do not dry clean','Non asciugare in asciugatrice':'Do not tumble dry',
      'Lavare in lavatrice a max 30 °C, ciclo delicato':'Machine wash at max 30°C, gentle cycle',
      'Stirare a max 110 °C':'Iron at max 110°C','Lavare separatamente':'Wash separately',
      'Heading':'Option information',
      'Add an additional description to your product option. Ex: Size guides, and other common questions.':'See additional information about this product option.',
      'Local Pickup Available':'Local pickup available',
      'You must be of legal drinking age to purchase wines.':'You must meet the legal age requirement to access restricted products.'
    },
    es: {
      'Spedizione gratuita da 70€ • 10% sul primo ordine con PRIMOORDINE':'Envío gratuito desde 70 € • 10% de descuento en tu primer pedido con PRIMOORDINE',
      'Scopri Partenopet':'Descubre Partenopet','Scopri la linea Partenopet':'Descubre la gama Partenopet','Acquista ora':'Comprar ahora',
      'Crocchette Pressate a Freddo per Cani':'Croquetas prensadas en frío para perros',
      'Crocchette Pressate a Freddo per Gatti':'Croquetas prensadas en frío para gatos',
      'Vedi tutti':'Ver todos','Mostra tutti':'Ver todos',
      'Chiedi informazioni':'Preguntar','Condividi con i tuoi amici':'Compartir con tus amigos','Condividi':'Compartir',
      'Descrizione prodotto':'Descripción del producto','Prodotti Complementari':'Productos complementarios','Prodotti complementari':'Productos complementarios',
      'Altri prodotti':'Más productos','Prodotti visti di recente':'Productos vistos recientemente','Prodotti consigliati':'Productos recomendados',
      'Prodotti raccomandati':'Productos recomendados','GUIDA TAGLIE':'GUÍA DE TALLAS','CONSIGLI DEGLI SPECIALISTI':'CONSEJOS DE ESPECIALISTAS',
      'Materiali':'Materiales','Caratteristiche':'Características','Cura e manutenzione':'Cuidado y mantenimiento',
      'Informazioni sulla variante':'Información sobre la variante','Informazioni sul colore':'Información sobre el color',
      "Seleziona l'opzione più adatta alle tue esigenze.":'Selecciona la opción que mejor se adapte a tus necesidades.',
      'Seleziona il colore che preferisci.':'Selecciona el color que prefieras.',
      'Pagamenti sicuri: PayPal, Klarna e carte':'Pagos seguros: PayPal, Klarna y tarjetas',
      'Spedizione gratuita da 70€':'Envío gratuito desde 70 €',
      'Tempi di consegna indicati chiaramente per ogni prodotto':'Plazos de entrega indicados claramente para cada producto',
      'Consegna: 1–4 giorni; alcuni articoli 7–14 giorni':'Entrega: 1–4 días laborables; algunos artículos 7–14 días laborables',
      "Prendersi cura dei prodotti aiuta anche a ridurne l'impatto ambientale. Segui sempre le indicazioni specifiche del prodotto e utilizza metodi di pulizia delicati quando possibile.":
        'Cuidar los productos ayuda a prolongar su vida útil. Sigue siempre las indicaciones específicas y utiliza métodos de limpieza suaves cuando sea posible.',
      'Non lavare':'No lavar','Non usare candeggina o sbiancanti':'No usar lejía','Non stirare':'No planchar',
      'Non lavare a secco':'No lavar en seco','Non asciugare in asciugatrice':'No usar secadora',
      'Lavare in lavatrice a max 30 °C, ciclo delicato':'Lavar a máquina a máx. 30 °C, ciclo delicado',
      'Stirare a max 110 °C':'Planchar a máx. 110 °C','Lavare separatamente':'Lavar por separado',
      'Heading':'Información',
      'Add an additional description to your product option. Ex: Size guides, and other common questions.':'Consulta la información adicional de esta opción del producto.',
      'Local Pickup Available':'Recogida en tienda disponible'
    }
  };

  function replaceExactText(root, dict) {
    if (!root || !dict) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      const parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(parent.tagName)) return;
      const raw = node.nodeValue;
      const trimmed = raw.trim();
      if (!Object.prototype.hasOwnProperty.call(dict, trimmed)) return;
      node.nodeValue = raw.replace(trimmed, dict[trimmed]);
    });
  }

  function fixTermsLinks(lang) {
    document.querySelectorAll('.checkbox__label a').forEach(function (a) {
      const txt = (a.textContent || '').toLowerCase();
      if (!txt.includes('termin') && !txt.includes('terms')) return;
      const prefix = lang === 'en' ? '/en' : lang === 'es' ? '/es' : '';
      a.setAttribute('href', prefix + '/pages/termini-e-condizioni');
    });
  }

  function localize() {
    const lang = locale();
    if (!['it','en','es'].includes(lang)) return;
    if (lang !== 'it') {
      document.querySelectorAll('header, .menu-drawer__navigation').forEach(function (scope) {
        replaceExactText(scope, nav[lang]);
      });
    }
    replaceExactText(document.body, globalCopy[lang]);
    fixTermsLinks(lang);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', localize, { once: true });
  } else {
    localize();
  }
  document.addEventListener('shopify:section:load', localize);
})();